import React, { useState, useEffect } from 'react';
import SectionTitle from '../components/SectionTitle';
import '../styles/Contact.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.fade-up');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) setTimeout(() => e.target.classList.add('visible'), i * 80);
      });
    }, { threshold: 0.12 });
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}


const Contact = ({ onNavigate }) => {


  useReveal();

  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', profile: '', destination: '', message: '' });
  const onChange = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));
  const onSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "919790219690";

    const message = `
New Enquiry from Website

Name: ${form.firstName} ${form.lastName}
Email: ${form.email}
Phone: ${form.phone}
Profile: ${form.profile}
Destination: ${form.destination}

Message:
${form.message}
  `;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");

    setSent(true);

    setForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      profile: '',
      destination: '',
      message: ''
    });
  };

  return (
    <>
      <section className="page-hero">
        <div className="page-hero-bg" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1600&q=80')" }} />
        <div className="page-hero-content">
          <span className="section-tag">Get In Touch</span>
          <h1 className="page-hero-title">Contact <em>Pragya</em><br />HR Solutions</h1>
          <div className="section-line" />
        </div>
      </section>

      <section className="contact-body">
        <div className="contact-body__intro fade-up">
          <SectionTitle tag="Reach Us" heading="Let's Start a <em>Conversation</em>"
            sub="Our consultants are ready to guide you toward your global career goals. We respond within 24 hours." />
          {[
            { icon: <FaMapMarkerAlt />, title: 'Our Office', val: '294, Trichy Rd, Vivekanandha Nagar, Singanallur, Coimbatore, Tamil Nadu 641005' },
            { icon: <FaPhoneAlt />, title: 'Phone / WhatsApp', val: '+91 9790219690, +91 9042139092' },
            { icon: <FaEnvelope />, title: 'Email', val: 'info@pragyahr.in' },
            { icon: <FaClock />, title: 'Office Hours', val: 'Monday – Saturday\n10:00 AM – 6:00 PM IST' },
          ].map(d => (
            <div className="contact-detail" key={d.title}>
              <div className="contact-detail__icon">{d.icon}</div>
              <div>
                <div className="contact-detail__title">{d.title}</div>
                <div className="contact-detail__val" style={{ whiteSpace: 'pre-line' }}>{d.val}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="contact-form-wrap fade-up">
          <div className="contact-form__title">Send Us a Message</div>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <p style={{ color: 'var(--gold)', fontSize: 16, letterSpacing: 1 }}>Message Sent!</p>
              <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 8 }}>We'll be in touch within 24 hours.</p>
              <button className="btn-gold" style={{ marginTop: 24 }} onClick={() => setSent(false)}>Send Another</button>
            </div>
          ) : (
            <form onSubmit={onSubmit}>
              <div className="form-row">
                <div className="form-group"><label>First Name</label><input name="firstName" placeholder="Your first name" value={form.firstName} onChange={onChange} /></div>
                <div className="form-group"><label>Last Name</label><input name="lastName" placeholder="Your last name" value={form.lastName} onChange={onChange} /></div>
              </div>
              <div className="form-group"><label>Email Address</label><input type="email" name="email" placeholder="your@email.com" value={form.email} onChange={onChange} /></div>
              <div className="form-group"><label>Phone Number</label><input type="tel" name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={onChange} /></div>
              <div className="form-group"><label>I Am A</label>
                <select name="profile" value={form.profile} onChange={onChange}>
                  <option value="">Select your profile</option>
                  <option>Job Seeker — Looking for opportunities abroad</option>
                  <option>Employer — Looking to hire international talent</option>
                  <option>Student — Career guidance needed</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="form-group"><label>Preferred Destination</label>
                <select name="destination" value={form.destination} onChange={onChange}>
                  <option value="">Select destination</option>
                  <option>Russia</option><option>Middle East (UAE / Saudi / Qatar)</option>
                  <option>Singapore</option><option>Mauritius</option>
                  <option>HongKong</option><option>Open to any destination</option>
                </select>
              </div>
              <div className="form-group"><label>Your Message</label>
                <textarea name="message" placeholder="Tell us about your requirements..." value={form.message} onChange={onChange} />
              </div>
              <button type="submit" className="btn-gold btn-submit" style={{ width: '100%', padding: 16, fontSize: 11, letterSpacing: 3 }}>Send Message</button>
            </form>
          )}
        </div>
      </section>

      <section className="contact-map">

        {/* Google Map */}
        <div className="contact-map__map">
          <iframe
            title="Pragya HR Solutions Location"
            src="https://www.google.com/maps?q=Coimbatore,Tamil%20Nadu&output=embed"
            width="100%"
            height="500"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
          />
        </div>

        {/* Overlay Content */}
        <div className="contact-map__content">
          <p className="contact-map__eyebrow">Find Us</p>
          <h2 className="contact-map__heading">Our Location</h2>

          <div className="contact-map__card">
            <h3>Coimbatore, Tamil Nadu, India</h3>
            <p>Pragya HR Solutions — Global Reach, Local Excellence</p>

            <a
              href="https://maps.app.goo.gl/ieGyYHBt4TUMzgTa7"
              target="_blank"
              rel="noreferrer"
              className="contact-map__btn"
            >
              Open in Maps
            </a>
          </div>
        </div>

      </section>
    </>
  );
};
export default Contact;